<div class="title">
  <div class="back" routerLink="/user/profile/fleet">
    <img
      src="../../../../assets/images/Icon-jiantouxia.svg"
      [width]="20"
      [height]="20"
      alt=""
    />返回
  </div>
  系统公告
</div>
<mat-spinner [diameter]="86" *ngIf="loading"></mat-spinner>
<div class="content" *ngIf="!loading">
  <mat-accordion>
    <mat-expansion-panel hideToggle *ngFor="let item of announcements">
      <mat-expansion-panel-header>
        <div class="item">
          <div class="theme">系统公告</div>
          <div class="time">
            <app-datetime [text]="item.updated_time"></app-datetime>
          </div>
        </div>
      </mat-expansion-panel-header>
      <mat-list>
        <div [innerHTML]="item.content"></div>
      </mat-list>
    </mat-expansion-panel>
  </mat-accordion>
</div>
